import { component } from "picoapp";

export default component((node) => {
  const summary = node.querySelector("summary");
  const content = node.querySelector(".content");
  let animation = null;
  let isClosing = false;
  let isExpanding = false;
  const duration = 500;
  const easing = "ease-in-out";

  const handleClick = (e) => {
    e.preventDefault();
    node.style.overflow = "hidden";
    if (isClosing || !node.open) {
      handleOpen();
    } else if (isExpanding || node.open) {
      close();
    }
  };

  const close = () => {
    isClosing = true;
    const startHeight = `${node.offsetHeight}px`;
    const endHeight = `${summary?.offsetHeight}px`;
    handleAnimation(startHeight, endHeight, false);
  };

  const handleOpen = () => {
    node.style.height = `${node.offsetHeight}px`;
    node.open = true;
    window.requestAnimationFrame(() => expand());
  };

  const expand = () => {
    isExpanding = true;
    const startHeight = `${node.offsetHeight}px`;
    let endHeight;
    if (summary && content) {
      endHeight = `${summary?.offsetHeight + content?.offsetHeight}px`;
    } else {
      endHeight = "0px";
    }

    handleAnimation(startHeight, endHeight, true);
  };

  const handleAnimation = (startHeight, endHeight, opening) => {
    if (animation) {
      animation.cancel();
    }

    animation = node.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration,
        easing,
      }
    );

    animation.onfinish = () => onAnimationFinish(opening);
    animation.oncancel = () => {
      if (opening) {
        isExpanding = false;
      } else {
        isClosing = false;
      }
    };
  };

  const onAnimationFinish = (open) => {
    node.open = open;
    animation = null;
    isClosing = false;
    isExpanding = false;
    node.style.height = node.style.overflow = "";
  };

  summary?.addEventListener("click", handleClick);

  return () => {
    summary?.removeEventListener("click", handleClick);
  };
});
